import React, { FunctionComponent, useState } from 'react';
import { API } from '../../api/apiConstants';
import { ImageStyled, ImageTextOverlay } from '../../core/formBuilder/usePages';
import { Skeleton } from '@mui/material';
import ImageTextOverlayComponent from '../commons/ImageTextOverlayComponent';

interface ImageHeaderProps {
  image: ImageStyled;
  imageTextOverlay?: ImageTextOverlay;
}

export const ImageHeader: FunctionComponent<ImageHeaderProps> = ({
  image,
  imageTextOverlay = undefined,
}) => {
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  return image.identifier ? (
    <div style={{ position: 'relative' }}>
      <img
        src={API.V3.STATIC_RESOURCES.STATIC_RESOURCE(image?.identifier)}
        alt={image?.informativeGraphic && image.alt !== '' ? image.alt : ''}
        style={{
          width: '100%',
          objectFit: 'cover',
          objectPosition: image.style?.objectPosition ?? 'center',
          maxHeight: image.style?.maxHeight ?? '15vh',
          display: 'block',
        }}
        hidden={!imageLoaded}
        onLoad={() => setImageLoaded(true)}
        tabIndex={image?.informativeGraphic && image.alt !== '' ? 0 : -1}
      />
      {!imageLoaded && (
        <Skeleton
          variant="rectangular"
          style={{ width: '100%', height: image.style?.maxHeight ?? '15vh' }}
        />
      )}

      {/* Overlay text */}
      <ImageTextOverlayComponent textOverlay={imageTextOverlay} />
    </div>
  ) : null;
};
